<template>
<div class="container">

	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
		<div class="col-12">
			<div class="alert alert-danger">
				<strong>Use these options very carefully!</strong> This section is available primarily to perform testing and bug checking. Permanent changes to roles and permissions should always be be done via migrations.
			</div>

	    	<div class="d-flex align-items-center">
		    	<h1 class="flex-grow-1" data-test="pageTitle">Manage Permissions</h1>
		        <span
		        	v-tooltip.bottom="'Add Permission'"
		        	@click="showAddPermForm()"
		        	class="btn btn-sm btn-ghost-primary text-gray-500 leading-none">
		            <i class="far fa-plus-circle text-xl"></i>
		        </span>
		    </div>
		</div>	

	    <div class="col-12">
	    	<div v-if="show_form" class="card">
	    		<div class="card-header">New Permission</div>
				<table class="table">
					<thead>
						<th style="min-width:240px"></th>
						<th v-for="role in roles" class="text-center" :width="(100 / (1 + roles.length)) + '%'">{{ role.name }}</th>
					</thead>

					<tr>
						<td>
							<div class="form-group row mb-0">
								<label class="col-4 col-form-label-sm">Name:</label>
								<input class="col-8 form-control form-control-sm" v-model="form.name" required>
							</div>
							<div class="form-group row mb-0">
								<label class="col-4 col-form-label-sm">Category:</label>
								<input class="col-8 form-control form-control-sm" v-model="form.category" required>
							</div>
							<div class="text-right w-100">
					            <span class="btn btn-sm btn-outline-secondary mr-1" @click="stopEditing()">Cancel</span>
					            <span class="btn btn-sm btn-outline-primary" @click="savePerm()">Save</span>
							</div>
						</td>
						
						<td v-for="role in roles" class="text-center">
							<input type="checkbox" :value="role.id" v-model="form.roles">							
						</td>
					</tr>					
				</table>
	    	</div>

			<div v-for="(perms, index) in permissions" class="card">
				<div class="card-header">{{ index }}</div>
				<table class="table">
					<thead>
						<th style="min-width:240px"></th>
						<th v-for="role in roles" class="text-center" :width="(100 / (1 + roles.length)) + '%'">{{ role.name }}</th>
					</thead>
					
					<permission-item
						v-for="(perm, key) in perms"
						:perm="perm" :key="key"
						:roles="roles"
						@delete_perm="deletePerm($event)"
						@perm_saved="refetchPerms()"
					/>
				</table>
			</div>
		</div>
	</div>
</div>
</template>

<script>

	import { mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import PermissionItem from '../../components/PermissionItem';

	export default {
		mixins: [BreadcrumbsManager],

		components: {
			PermissionItem
		},

        data() {
            return {
                permissions: null,
                roles: null,
                data_loaded: false,
                show_form: false,
                form: {},
            }
        },

        created() {
        	this.fetchRoles();
        	this.fetchPerms();        	
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Users', to: { name: 'users.index'} },
                { text: 'Permissions', to: { name: 'permissions.index'} },
            ]); 
        },

        methods: {
        	deletePerm($event) {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'You will not be able to recover this permission.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Delete permission',
                      cancelButtonText: 'Keep permission',
                      animation: false,
                    }).then((result) => {
                    	if (result.value) {
                        	axios.delete('/api/permissions/' + $event, $event).then(() => {
                            	this.refetchPerms();
                            })
                        }
                    }
                );        		
        	},

        	fetchPerms() {
        		axios.get('/api/permissions').then(({data}) => {
	            	this.permissions = data;
	            	this.data_loaded = true;
	        	});
        	},

        	fetchRoles() {
        		axios.get('/api/roles').then(({data}) => {
                    this.roles = data.filter(role => role.name != 'sitewide admin');
	        	});
        	},  

        	newForm() {
                this.form = {
                    name: null,
                    category: null,
                    roles: [],
                }
        	},

        	refetchPerms() {
        		this.data_loaded = false;
        		this.fetchPerms();
        	},

            savePerm() {
                axios.post('/api/permissions', this.form).then(() => {
                    this.refetchPerms();
                    this.newForm();
                    this.show_form = false;
                });
            },

        	showAddPermForm() {
        		this.show_form = true;
        		this.newForm();
        	},

        },
    }
</script>